import { t } from 'i18next'

import Panel from '~/components/Panel'
import Table from '~/components/Table'
import { Badge } from '~/components/UI/Badge'

type ReviewCampaignCategory = {
  category_id: string
  name: string
  disabled_at?: string
}

const schema = (): TableSchema<ReviewCampaignCategory> => ({
  title: {
    title: t('rm:campaign.targeting.category.title'),
    render: rowData => {
      const isPaused = !!rowData.disabled_at

      return (
        <>
          <span
            style={
              isPaused ? { color: 'var(--sl-fg-base-disabled)' } : undefined
            }
          >
            {rowData.name}
          </span>
          {isPaused && (
            <>
              {' '}
              <Badge template="warning">
                {t('c:capitalize', {
                  value: t('rm:paused', { context: 'female' })
                })}
              </Badge>
            </>
          )}
        </>
      )
    },
    className: 'order__details col__infos col__title'
  }
})

const ReviewCampaignCategories = ({
  categories
}: {
  categories: ReviewCampaignCategory[]
}) => {
  return (
    <Panel
      template="shoreline"
      title={t('rm:campaign.targeting.category.title')}
      isCollapsible
      initialCollapsibleState={false}
      unmountContentIfCollapse
      noPaddingBody
    >
      <div data-testid="review-campaign-categories-table">
        <Table
          schema={schema()}
          data={categories}
          hasHeader={false}
          striped
          sideBorder
          smallerRowPadding
        />
      </div>
    </Panel>
  )
}

export default ReviewCampaignCategories
